export default "__VITE_ASSET__0c4938c8__"